import { takeEvery } from 'redux-saga/effects';

import * as homeActions from 'store/modules/home';
import { loadFeaturedModels } from './utils';

export default function* listenLoadFeaturedModels() {
  yield takeEvery(homeActions.loadFeaturedModels.toString(), loadFeaturedModels);
}
